import 'reset-css'
import './style.css'
import './favicon.ico'

const noaaMarineWeather = (endpoint, title, sections) => {
  document.body.classList.remove('loaded')
  document.body.setAttribute('data-forecast', title)
  return fetch('https://api.allorigins.win/get?url=' + 'http://tgftp.nws.noaa.gov/data/raw/' + endpoint, {
    headers: {
      Origin: 'Sitka'
    }
  }).then(function(response) {
    return response.json()
  }).then(function(json) {
    let forecasts = json.contents.match(/(?:\w{3}\d{3}-\d{6}-)([^$]+)/g)
    const timestamp = forecasts[0].match(/(\d+\s(AM|PM)[^\n]+)/)[0]
    forecasts = forecasts
      .map(f => f.replace(/\w{3}\d{3}-\d{6}-\n/, ''))
      .map(f => f.replace(/^([\w\s]+)-$/gm, '<h2>$1</h2>'))
      .map(f => f.replace(/\.{3}(\w[\w\s]+)\.{3}/g, '<strong class="alert">$1</strong> '))
      .map(f => {
        let i = 0
        return f
          .replace(/\.{1}(\w[\w\s]+)\.{3}/g, '.<div class="day"><em>$1</em> ')
          .replace(/\n\.<div class="day">/g, () =>
            i++ === 0 ? '\n<div class="day">' : '\n</div><div class="day">'
          )
      })
      .map(f => f.replace(/\n\./g, '<br />'))
      .map(f => f.replace(/Including the (city|cities) of ([^\n]+)/g, '<span class="locale">$2</span>'))
      // .map(f => f.replace(/(\d+\s(AM|PM)[^\n]+)/g, '<span class="timestamp">$1</span>'))
      .map(f => f.replace(/(\d+\s(AM|PM)[^\n]+)/g, ''))
      .map(f => f.replace(/\n/, ''))
      .map(f => '<section data-type="marine">' + f + '</div></section>')
    const forecast = sections.map(s => forecasts[s]).join('')
    out.innerHTML += `
      <h1 data-title="${title}">${title}</h1>
      <span class="timestamp">${timestamp}</span>
      ${forecast}`
    document.body.classList.add('loaded')
  }).catch((e) => {
    document.body.classList.add('error')
    out.innerHTML += `
      <h1 class="error">Error: Failed To Load ${title}</h1>
      <section><div class="day">ERROR</div>${e}</section>
    `
  })
}
const noaaZoneWeather = (endpoint, title, zones, periodsOut) => {
  document.body.classList.remove('loaded')
  document.body.setAttribute('data-forecast', title)
  return fetch('https://api.allorigins.win/get?url=' + 'http://www.weather.gov/source/arh/' + endpoint)
  .then(r => r.json())
  .then(j => {
    const json = JSON.parse(j.contents)
    return zones.map(z => json.zone[z])
  })
  .then(z => {
    const timestamp = z[0].header.match(/((\d+)\s(AM|PM)[^\n]+)/i)[0]
    document.body.setAttribute('data-timestamp', / AM /i.test(timestamp) ? 'AM' : 'PM')
    document.body.setAttribute('data-after-eleven', parseInt(z[0].header.match(/((\d+)\s(AM|PM))/i)[2], 10) > 1100);
    const forecasts = z.map(zone => {
      let city = zone.header.match(/primary forecast for ([^\n]+)/i),
          // addtl = zone.header.match(/additional information included for ([^\n]+)/i),
          time = zone.header.match(/(\d+\s(AM|PM)[^\n]+)/i),
          addtl = '',
          count = 0,
          alert = zone.cap
            ? zone.cap
            : []

      city = city !== null && city.length > 1 ? city[1] : ''
      // addtl = addtl !== null && addtl.length > 1 ? `<span class="small">(${addtl[1]})</span>` : ''
      // addtl = addtl !== null && addtl.length > 1 ? addtl.replace(/,? and /, ', ').split(', ') : []

      // Adjust city names to KCAW custom
      switch(city) {
        case 'SITKA':
          // Additional information for Port Alexander now accompanies Kake forecast (10)
          // addtl = 'and Port Alexander'
          break
        case 'HOONAH':
          city = 'TENAKEE SPRINGS'
          break
        case 'PELICAN':
          addtl = 'and Elfin Cove'
          break
        case 'ANGOON':
          break
        // Kake now has it’s own forecast with additional information for Port Alexander
        // case 'PETERSBURG':
        //   city = 'KAKE'
        //   break
        case 'KAKE':
          addtl = 'and Port Alexander'
          break
        case 'YAKUTAT TOWN':
          city = 'YAKUTAT'
          break
      }

      let periods = zone.period.map(period => {
        // If we've matched our limit, reset count
        if(count === periodsOut) return false
        // Increment period count only when period name is today, monday, tonight, etc
        if(/(day|night)/i.test(period.name)) {
          count++
        }
        return `
          <div class="day" data-index=${count} data-name="${period.name.replace('.', '')}">
            <em>${period.name.replace(/\./g, '')}</em>
            ${period.text}
          </div>
        `
      }).filter(p => p !== false).join('')

      return `
        <section data-type="zone" data-name="${city}">
          <h2>${city} ${addtl}</h2>
          ${alert.map(a => `<strong class="alert">${a.capSummary.replace(/\.\.\./g, "")}</strong>`)}
          ${periods}
        </section>
      `
    })
    const forecast = forecasts.join('')
    document.querySelector('#out').innerHTML += `
      <h1 data-title="${title}">${title}</h1>
      <span class="timestamp">${timestamp}</span>
      ${forecast}`
    document.body.classList.add('loaded')
  }).catch((e) => {
    document.body.classList.add('error')
    document.querySelector('#out').innerHTML += `
      <h1 class="error">Error: Failed To Load ${title}</h1>
      <section><div class="day">ERROR</div>${e}</section>
    `
  })
}
const hashchange = (e) => {
  if(window.location.hash !== hash || e._FORCE_HASH_UPDATE) {
    switch(window.location.hash) {
      case '#zone':
        out.innerHTML = ''
        /*
         * OLD FORECAST
         * 0 (6): Sitka and Port Alexander ("Primary forecast for Sitka") ——— NEW ZONES: Sitka remains (6), but Port Alexander now accompanies Primary forecast for Kake
         * 1 (4): Tenakee Springs
         * 2 (5): Pelican and Elfin Cove
         * 3 (7): Angoon
         * 4 (9): Kake ——— NEW ZONES: Kake is now (10), and is accompanied by additional information for port alexander weather
         * 5 (0): Yakutat
         * NEW FORECAST
         * 0 (6): Sitka
         * 1 (10): Kake and Port Alexander
         * 2 (7): Angoon
         * 3 (4): Tenakee Springs
         * 4 (5): Pelican and Elfin Cove
         * 5 (0): Yakutat
         */
        noaaZoneWeather(
          'lfp_ajk.json',
          'Zone Forecast for Southeast Alaska',
          // [6, 4, 5, 7, 9, 0],
          [
            6,  // Sitka,
            10, // Kake and Port Alexander,
            7,  // Angoon
            4,  // Tenakee Springs (Hoonah)
            5,  // Pelican and Elfin Cove
            0,  // Yakutat (Yakutat Town)
          ],
          3
        )
        break
      case '#marine':
        out.innerHTML = ''
        noaaMarineWeather(
         'fz/fzak52.pajk.cwf.aeg.txt',
         'Marine Forecast for Southeast Alaska Outside Waters',
         [0, 2, 3, 4]
        ).then(() => noaaMarineWeather(
         'fz/fzak51.pajk.cwf.ajk.txt',
         'Marine Forecast for Southeast Alaska Inside Waters',
         [4, 5, 7, 8]
        ))
        break
      default:
        document.body.classList.add('loaded')
        document.body.setAttribute('data-forecast', 'none')
        document.body.setAttribute('data-timestamp', 'none')
        document.body.setAttribute('data-after-eleven', 'none')
        break
    }
    hash = window.location.hash
  }
}

document.querySelector('#print').addEventListener('click', (e) => window.print())
document.querySelector('#smaller').addEventListener('click', (e) => {
  document.body.style.fontSize = `${(document.body.style.fontSize ? document.body.style.fontSize.match(/\d+/)[0] : 100) * 0.95}%`
})
document.querySelector('#larger').addEventListener('click', (e) => {
  document.body.style.fontSize = `${(document.body.style.fontSize ? document.body.style.fontSize.match(/\d+/)[0] : 100) * 1.05}%`
})

const out = document.querySelector('#out')
let hash = window.location.hash
hashchange({ _FORCE_HASH_UPDATE: true })
window.addEventListener('hashchange', hashchange)



// WEBPACK FOOTER //
// ./src/index.js